import * as React from 'react';

import { HELPFIND_PHONE } from '@/consts';
import { useAdditionalInfoContext } from '@/features/v2/lib/additionalInfo';

import { useLingui } from '@lingui/react';
import * as ToastPrimitive from '@radix-ui/react-toast';

interface ToastProps {
  title: string;
  opened?: boolean;
  duration?: number;
  withPhone?: boolean;
}

const CustomToast: React.FC<ToastProps> = ({
  title,
  duration = 5000,
  withPhone = false,
}) => {
  const [open, setOpen] = React.useState(false);
  const { error, setError } = useAdditionalInfoContext();
  const { i18n } = useLingui();

  React.useEffect(() => {
    setOpen(error);
    if (error) {
      setTimeout(() => {
        setError(false);
      }, 5000);
    }
  }, [error, setError]);

  return (
    <ToastPrimitive.Provider swipeDirection="up">
      <ToastPrimitive.Root
        className="grid grid-cols-[auto_max-content] items-center gap-x-[15px] rounded-md border border-red-200 bg-red-50 p-[15px] shadow-xl [grid-template-areas:_'title_action'_'description_action'] data-[swipe=cancel]:translate-x-0 data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[state=closed]:animate-hide data-[state=open]:animate-slideIn data-[swipe=end]:animate-swipeOut data-[swipe=cancel]:transition-[transform_200ms_ease-out]"
        open={open}
        onOpenChange={setOpen}
        duration={duration}
      >
        <ToastPrimitive.Title className=" text-red-500">
          <div className="flex flex-col gap-1">
            <span className="font-semibold text-red-500">{title}</span>
            {withPhone && (
              <span className="text-red-500">
                {i18n.t('Skontaktuj się z nami:')}{' '}
                <a
                  className="text-red-500 underline"
                  href={`tel:${HELPFIND_PHONE}`}
                >
                  {HELPFIND_PHONE}
                </a>
              </span>
            )}
          </div>
        </ToastPrimitive.Title>
      </ToastPrimitive.Root>
      <ToastPrimitive.Viewport className="fixed bottom-0 right-0 z-[2147483647] m-0 flex w-[390px] max-w-[100vw] list-none flex-col gap-2.5 p-[var(--viewport-padding)] outline-none [--viewport-padding:_25px]" />
    </ToastPrimitive.Provider>
  );
};

export default CustomToast;
